import React from 'react';
import {Typography} from "@mui/material";
import LoggedLayout from "../../component/LoggedLayout";

 const GatheringView = () => {
    return (
        <LoggedLayout>
            <Typography>Gathering view</Typography>
        </LoggedLayout>
    )
}

export default GatheringView